import { Component, Input } from '@angular/core';
import { BadgeComponent } from 'vcp-common-ui-lib';
import { TaskBadgeStatusPipe, TaskStatusIconPipe, TaskStatusPipe } from '../../pipe/status.pipe';

@Component({
    selector: 'vc-task-status-chip',
    templateUrl: './task-status-chip.component.html',
    styleUrls: ['./task-status-chip.component.scss'],
    imports: [TaskStatusPipe, TaskBadgeStatusPipe, TaskStatusIconPipe, BadgeComponent],
})
export class TaskStatusChipComponent {
    @Input()
    status!: string;
}
